import React, { forwardRef, useRef } from 'react';
import Type from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useEffectOnce } from 'react-use';
import { AutoSizer, List, CellMeasurer, CellMeasurerCache } from 'react-virtualized';
import TaskItem from '../TaskItem';
import styles from './TaskList.module.css';

const cache = new CellMeasurerCache({
  fixedWidth: true,
  defaultHeight: 200,
});

const TaskList = forwardRef((props, ref) => {
  const { tasks, listHeight } = props;
  const taskListRef = useRef(null);
  const history = useHistory();

  useEffectOnce(() => {
    cache.clearAll();
  });

  const handleTaskClick = (taskId) => {
    history.push(`/organizer/tasks/${taskId}`);
  };

  const rowRenderer = (rowData) => {
    const { index, parent, key, style } = rowData;
    const item = tasks[index];

    return (
      <CellMeasurer cache={cache} columnIndex={0} key={key} parent={parent} rowIndex={index}>
        <div style={style}>
          <TaskItem
            positionNumber={key}
            key={item.id}
            task={item}
            onSelect={handleTaskClick}
            taskListRef={taskListRef}
            showDate
            showTime
          />
        </div>
      </CellMeasurer>
    );
  };

  const rowCount = tasks.length;

  return (
    <div ref={taskListRef}>
      <AutoSizer disableHeight>
        {({ width }) => (
          <List
            ref={ref}
            className={styles.list}
            getScrollbarSize={() => 0}
            height={listHeight}
            overscanRowCount={10}
            rowCount={rowCount}
            deferredMeasurementCache={cache}
            rowHeight={cache.rowHeight}
            rowRenderer={rowRenderer}
            width={width}
          />
        )}
      </AutoSizer>
    </div>
  );
});

TaskList.propTypes = {
  listHeight: Type.number.isRequired,
  tasks: Type.arrayOf(Type.shape(TaskItem.propTypes.task)).isRequired,
};

export default TaskList;
